export enum ECountry {
	colombia = 'colombia',
	argentina = 'argentina',
	mexico = 'mexico',
	unknown = 'unknown',
}

export const COUNTRIES = [ECountry.colombia, ECountry.mexico, ECountry.argentina]

export enum EPhoneNumberCode {
	colombia = '+57',
	argentina = '+54',
	mexico = '+52',
}

export interface IPhoneNumberCode {
	code: EPhoneNumberCode
	country: ECountry
}
